import { FaCubes as CubesIcon } from 'react-icons/fa';

export default CubesIcon;
